import { render, staticRenderFns } from "./EditableList.vue?vue&type=template&id=63fa2143"
import script from "./EditableList.vue?vue&type=script&lang=js"
export * from "./EditableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports